import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Adressat, AdressatWithResource } from '../aufgabe.model';
import { AufgabeRootState } from '../aufgabe.state';
import {
	createAdressatAction,
	deleteAdressatAction,
	updateAdressatChannelAction,
	updateAdressatNotizAction,
} from './adressat.actions';

@Injectable({ providedIn: 'root' })
export class AdressatFacade {
	constructor(private store: Store<AufgabeRootState>) {}

	createAdressat(adressat: Adressat, kontaktId: number) {
		this.store.dispatch(createAdressatAction({ adressat, kontaktId }));
	}

	updateChannel(adressat: AdressatWithResource) {
		this.store.dispatch(updateAdressatChannelAction({ adressat }));
	}

	updateNotiz(adressat: AdressatWithResource) {
		this.store.dispatch(updateAdressatNotizAction({ adressat }));
	}

	deleteAdressat(adressat: AdressatWithResource) {
		this.store.dispatch(deleteAdressatAction({ adressat }));
	}
}
